<script>
  import InstalledBaseView from './InstalledBaseView.svelte'
  import { installedBaseAPI } from './api.js'
  import { push } from 'svelte-spa-router'
  import Button from 'smelte/src/components/Button'
  import Metrics from '../Metrics.svelte'
  import { faFileAlt } from '@fortawesome/free-regular-svg-icons'
  import { faList } from '@fortawesome/free-solid-svg-icons'
  import { machineFilters, selectedInstalledBase, userStore } from '../../store'
  import { arrayFilterByRoles, objectFilterByRoles } from '../../roles'
  import { onDestroy, onMount } from 'svelte'

  export let params = {}

  const api = new installedBaseAPI()

  let locationLabel = ''
  let actionsLabel = 'Conveyor condition monitoring'

  let _columns = [
    {label: 'ID', field: 'no', add: 'text-center', w: '20', iconAfter: true},
    {label: 'Project number', field: 'su_erp_proj', add: '', w: '20', iconAfter: true},
    {label: 'Sales office', field: 'country_key', add: '', w: '12', iconAfter: true},
    {label: 'Platform', field: 'model', add: '', w: '20', iconAfter: true},
    {label: 'Machine model / Product group', field: 'ProductGroup', add: '', w: '20', iconAfter: true},

    {
      label: 'Complete unit number', field: 'unit_serial', add: '', w: '20', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'Robot arm serial number', field: 'sn', add: '', w: '20', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'Machine status', field: 'status', add: '', w: '20', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'Operation speed', field: 'op_speed', ro: false, add: '', w: '20', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'Hours', field: 'hours', ro: false, add: '', w: '20', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'Weight, kg', field: 'prod_weight', ro: false, add: '', w: '20', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      label: 'Notes', field: 'notes', ro: false, add: '', w: '20', iconAfter: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    }

    // {label: 'Sales unit', field: 'sales_unit', add: '', w: '24', iconAfter: true},
    // {label: 'Sales Unit', field: 'sales_unit', add: '', w: '24', iconAfter: true},
    // {label: 'End-User name', field: 'eu_name', add: '', w: '56', iconAfter: true},
    // {label: 'End-User country', field: 'eu_country', add: '', w: '40', iconAfter: true},
    // {label: 'Key account', field: 'GKAM', add: '', w: '48', iconAfter: true},
    // {label: 'Service agreement', field: 'sa', add: '', w: '32', iconAfter: true},
    // {label: 'End service agreement', field: 'sa_end', add: '', w: '32', iconAfter: true},
    // {label: 'Tech', field: 'tech', ro: false, add: '', w: '24', iconAfter: true},
    // {label: 'User', field: 'm_modified_by', add: '', w: '32', iconAfter: true},
    // {label: 'Modified', field: 'm_modified_fmt', add: '', w: '32', iconAfter: true},
    // {label: 'Warranty end date', field: 'WarrantyDate', add: '', w: '48', iconAfter: true},
    // {label: 'Asset value', field: 'asset_value', add: '', w: '48', iconAfter: true}
  ]

  let exportColumns = [
    { label: 'ID', field: 'no'},
    { label: 'Project Number', field: 'su_erp_proj'},
    { label: 'Sales office', field: 'country_key'},
    { label: 'Platform', field: 'model'},
    { label: 'Machine model/Product group', field: 'ProductGroup'},
    { label: 'Complete unit number', field: 'unit_serial'},
    { label: 'Robot arm serial number', field: 'sn'},
    { label: 'Machine status', field: 'status'},
    { label: 'Operation speed', field: 'op_speed'},
    { label: 'Hours', field: 'hours'},
    { label: 'Weight, kg', field: 'prod_weight'},
    { label: 'Notes', field: 'notes'},
    { label: 'Operation center', field: 'op_center'},
    { label: 'Operation Center ERP project number', field: 'LinkedProject'},
    { label: 'Key account', field: 'GKAM'},
    { label: 'Customer contact name', field: 'Reference'},
    { label: 'Customer contact email', field: 'Email'},
    { label: 'Service agreement', field: 'sa'},
    { label: 'End service agreement', field: 'sa_end'},
    { label: 'SAT signed?', field: 'is_sat'},
    { label: 'SAT signature date', field: 'SATDate'},
    { label: 'Warranty end date', field: 'WarrantyDate'},
    { label: 'Asset value', field: 'AssetValue'},
    { label: 'Ship to customer number', field: 'shcu_no'},
    { label: 'Ship to customer name', field: 'shcu_name'},
    { label: 'Ship to city', field: 'shcu_city'},
    { label: 'Ship to country', field: 'shcu_country'},
    { label: 'Ship to address', field: 'shcu_street'},
  ]

  let actions = [
    {name: 'new-protocol', icon: faFileAlt, hint: 'New protocol'},
    {name: 'protocols', icon: faList, hint: 'Protocols list'},
  ]

  let columns = []
  let filters = {}

  $: {
    columns = arrayFilterByRoles(_columns, $userStore.roles)
    filters = objectFilterByRoles($machineFilters, $userStore.roles)
  }

  onMount(() => {
    filters = $machineFilters
  })

  onDestroy(() => {
    $machineFilters = filters
  })

  let getMachines = function (locations, selectedLocation, resolve) {
    let machines = locations.filter(l => l.su_erp_proj === selectedLocation.su_erp_proj)
    resolve(machines)
  }

  let setLocationID = function (l) {
    l.id = l.no
  }

  let locationsHandler = 'getInstalledBaseList'

  function actionHandler ({detail}) {
    if (detail.action.name === 'protocols') {
      $selectedInstalledBase = {no: null}
      push('/condition-monitoring?id=' + detail.item.no)
    }
    if (detail.action.name === 'new-protocol') {
      $selectedInstalledBase = detail.item
      push('/condition-monitoring/protocol/new?machine_no=' + detail.item.no)
    }
  }

</script>

<Metrics />

<div class="mx-10 md:mx-12 lg:mx-12 ">
  <InstalledBaseView
    {params}
    {locationLabel}
    {columns}
    {actions}
    {actionsLabel}
    {filters}
    {getMachines}
    {setLocationID}
    {locationsHandler}
    on:action={actionHandler}
    {exportColumns}
  >
<span slot="action-buttons">
    <Button text color="red"
            style="margin-left: -12px"
            on:click={() => { push('/installed-base/projects') }}>
      Show projects view
    </Button>
  </span>
  </InstalledBaseView>
</div>